import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonItemOption, IonItemOptions, IonItemSliding, IonLabel, IonModal, IonTitle, IonToolbar } from '@ionic/react'
import { closeOutline, createOutline, trashOutline } from 'ionicons/icons'
import { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { startEquipoUpdated } from '../../../actions/equipos'
import { setActiveLoading, setModalTagHide, setModalTagShow } from '../../../actions/ui'
import { RootState } from '../../../reducers/rootReducer'

const initForm = {
  tag: '',
}

export const TagItem: FC = () => {
  const dispatch = useDispatch();
  const { activeEquipo: { tag } } = useSelector((state: RootState) => state.equipo);
  const { editTag } = useSelector((state: RootState) => state.ui);

  const handleDelete = () => {
   
  }
  const handleUpdate = () => {
    dispatch(setModalTagShow())

  }
  return (
    <IonItem>
      <IonLabel className="item-label" position="stacked" color="primary">
        Tag
      </IonLabel>
      <IonItemSliding>
        <IonItem lines="none">
          <IonLabel>{tag}</IonLabel>
          {editTag && <TagModal />}
        </IonItem>
        <IonItemOptions side="end" color="light">
          <IonItemOption color="light" onClick={() => { handleUpdate() }}><IonIcon className="icon-list" color="success" ariaLabel="Editar" title="Editar" icon={createOutline}></IonIcon></IonItemOption>
          <IonItemOption color="light" onClick={() => { handleDelete() }}><IonIcon className="icon-list" color="danger" icon={trashOutline}></IonIcon></IonItemOption>
        </IonItemOptions>
      </IonItemSliding>
    </IonItem>
  )
}

const TagModal: FC = () => {
  const dispatch = useDispatch();

  const { editTag } = useSelector((state: RootState) => state.ui);
  const { activeEquipo } = useSelector((state: RootState) => state.equipo);

  const [formValues, setFormValues] = useState(initForm);
  const { tag } = formValues;

  useEffect(() => {
    if (activeEquipo) {
      const t = {tag: activeEquipo.tag};
      setFormValues(t)
    } else {
      setFormValues(initForm)
    }
  }, [activeEquipo])

  const handleInputChange = ({ target }) => {
    setFormValues({
      ...formValues,
      [target.name]: target.value,
    });
  };

  const equipo = {
    tag: tag,
    nombre_equipo: activeEquipo.nombre_equipo,
    descripcion_equipo: activeEquipo.descripcion_equipo,
    central: activeEquipo.central !== null ? activeEquipo.central._id : "",
    numero_equipo: activeEquipo.numero_equipo,
    type: activeEquipo.type
  };

  const handleUpdate = (e: any) => {
    e.preventDefault();
    dispatch(setActiveLoading());
    dispatch(startEquipoUpdated(equipo));
    dispatch(setModalTagHide())
  };

  const handleClose = () => {
    dispatch(setModalTagHide());
  };
  return (
    <IonContent>
      <IonModal isOpen={editTag} cssClass='modal-unit-iput'>
        <IonHeader className="ion-no-border">
          <IonToolbar>
            <IonTitle color="dark">Tag</IonTitle>
            <IonButtons slot="end">
              <IonButton color="primary" onClick={handleClose}>
                <IonIcon icon={closeOutline}></IonIcon>
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent className="marca-container">
          <form onSubmit={handleUpdate}>
            <IonItem lines="inset">
              <IonInput
                type="text"
                name="tag"
                value={tag}
                onIonChange={handleInputChange}
                placeholder="Tag"
              ></IonInput>
            </IonItem>
            <IonItem lines="none">
              <IonButton slot="end" fill="clear" type="submit">
                Guardar
              </IonButton>
              <IonButton slot="end" fill="clear" onClick={handleClose}>
                Cancelar
              </IonButton>
            </IonItem>          
          </form>
        </IonContent>
      </IonModal>
    </IonContent>
  );
}
